import {h, render, createElement} from 'preact';
import {useState, useEffect} from 'preact/hooks';

import {LoadingIndicator, SchoolSelect, TextInput, TriggerManualInput} from './Components';

// Polyfill
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position) {
        position = position || 0;

        return this.indexOf(searchString, position) === position;
    };
}

const FETCH_SCHOOLS_URL = '/school/postalcodequery?postalCodeQuery=';

const AppContent = (props) => (
    <div>
        <TextInput
            name="nameThatDoesntReferToAPossibleAutofillValue"
            value={props.inputPostalCode}
            updateValue={props.setInputPostalCode}
            required={!props.isEnabledManualInput}
        />

        {
            props.isFetching &&
                <LoadingIndicator/>
        }

        <div className="schoolSelectContainer">
            {
                Object.keys(props.selectedSchool).length === 0 &&
                !props.isEnabledManualInput &&
                    <input type="text" value="" required="required" className="hiddenInputHelper"/>
            }

            {
                props.matchingSchools.length > 0 &&
                !props.isFetching &&
                !props.isEnabledManualInput &&
                    <SchoolSelect
                        key={Date.now()}
                        name="schools"
                        schools={props.matchingSchools}
                        selectedSchool={props.selectedSchool}
                        updateSchool={props.setSelectedSchool}
                        onManualInput={props.enableManualInput}
                    />
            }
        </div>

        {
            props.foundNoMatchingSchools &&
                <div class="postalCodeNotFound">Diese Postleitzahl ist uns nicht bekannt. Bitte manuelle Eingabe wählen.</div>
        }

        {
            props.isEnabledManualInput ?
                <h4 className="helperHeadline_ManualInput">Manuelle Eingabe</h4> :
                <TriggerManualInput enable={props.enableManualInput}/>
        }
      </div>
);

const App = ({onSchoolSelect, onToggleManualInput}) => {
    // STATE
    const [inputPostalCode, setInputPostalCode] = useState('');
    const [isEnabledManualInput, setIsEnabledManualInput] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const [selectedSchool, setSelectedSchool] = useState({});
    const [cachedSchools, setCachedSchools] = useState({});

    // EFFECTS
    useEffect(() => {
        setSelectedSchool({});
        setIsEnabledManualInput(false);

        if (inputPostalCode.length > 5) {
            setInputPostalCode(inputPostalCode.substr(0, 5));
        }

        if (inputPostalCode.length === 4 && !cachedSchools[inputPostalCode]) {
            setIsFetching(true);

            setCachedSchools({
                ...cachedSchools,
                [inputPostalCode]: []
            });

            fetch(FETCH_SCHOOLS_URL + inputPostalCode, {headers: {'Content-Type': 'application/json'}})
                .then(response => {
                    try {
                        if (response.ok) {
                            response.json()
                                .then((matchingSchools = []) => {
                                    setCachedSchools({
                                        ...cachedSchools,
                                        [inputPostalCode]: matchingSchools
                                    });
                                });
                        }
                    }
                    finally {
                        setIsFetching(false);
                    }
                })
        }
    }, [inputPostalCode]);

    useEffect(() => onToggleManualInput(isEnabledManualInput), [isEnabledManualInput]);

    useEffect(() => onSchoolSelect(selectedSchool, inputPostalCode), [selectedSchool]);

    // STATE-REDUCER.
    const enableManualInput = () => {
        setSelectedSchool({});
        setIsEnabledManualInput(true);
    };

    const matchingSchools = (cachedSchools[inputPostalCode.substr(0,4)] || [])
        .filter(({postalCode}) => postalCode.startsWith(inputPostalCode));

    const foundNoMatchingSchools = matchingSchools.length === 0 && inputPostalCode.length >= 4 && !isFetching;

    return (
        <AppContent {...{
            matchingSchools,
            inputPostalCode,
            foundNoMatchingSchools,
            isFetching,
            isEnabledManualInput,
            selectedSchool,
            setInputPostalCode,
            enableManualInput,
            setSelectedSchool
        }}/>
    );
};

export default (el, api) => render(
    createElement(App, api),
    el,
    el
);
